import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup"; // Import Yup
import {
  VenueFacilities,
  VenueServices,
  VenueType,
} from "../../../constants/VenueDetailsData";
import { useUser } from "../../../context/UserContext";
import httpServices from "../../../services/httpServices";
import { toast } from "react-toastify";
import LoadingOverlay from "../../../component/common/overlay";
import Input from "../../../component/common/Input";

// Define Yup validation schema
const validationSchema = Yup.object().shape({
  venueType: Yup.array()
    .min(1, "At least one venue type must be selected")
    .required("Venue type is required"),
  venueRequiredFacility: Yup.array().min(
    1,
    "At least one facility must be selected"
  ),
  venueReuiredService: Yup.array().min(
    1,
    "At least one service must be selected"
  ),
});

function OtherDetails({ setActiveStep, venueId, venueData }) {
  const { user } = useUser();
  const [loading, setLoading] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
    clearErrors,
    watch,
  } = useForm({
    resolver: yupResolver(validationSchema), // Apply Yup schema with yupResolver
    defaultValues: {
      venueType: venueData?.venueType || [],
      venueRequiredFacility: venueData?.venueRequiredFacility || [],
      venueReuiredService: venueData?.venueReuiredService || [],
    },
  });

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      const { response, error } = await httpServices.put(
        `/venue/update/${venueId}`,
        {
          stepsDone: 6,
          userId: user?.userId,
          ...data,
        }
      );
      if (error) {
        throw error;
      }
      if (response.status === 200) {
        setActiveStep(6);
        toast.success("Venue created successfully");
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };
  const onError = (error) => {
    if (venueData === null || venueData?.stepsDone < 5) {
      toast.warn("Please complete the previous step");
      clearErrors();
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit, onError)}>
      <div className="mt-3 p-3 bg-white relative">
        {loading && <LoadingOverlay />}
        <h3 className="text-blue fw-semibold text-xl mb-4">Other Details</h3>

        {/* Venue Type Section */}
        <section className="mb-4">
          <h4 className="font-medium text-base mb-3">
            What is the venue Type*
          </h4>
          <div className="row row-cols-lg-6 row-cols-md-3 row-cols-2">
            {VenueType?.map((type) => (
              <div key={type} className="col mb-3">
                <div className="flex gap-2 items-center">
                  <Input
                    type="checkbox"
                    {...register("venueType")}
                    value={type}
                    // checked={venueData?.venueType?.includes(type)}
                    defaultChecked={venueData?.venueType?.includes(type)}
                    className="common-checkbox"
                  />
                  <label className="text-[#4E5969] text-xs mt-[10px]">
                    {type}
                  </label>
                </div>
              </div>
            ))}
          </div>
          {errors.venueType && (
            <p className="text-red-500 text-xs">{errors.venueType.message}</p>
          )}
        </section>

        {/* Facilities Section */}
        <section className="mb-4">
          <h4 className="font-medium text-base mb-3">
            Facilities that are required
          </h4>
          <div className="row row-cols-lg-6 row-cols-md-3 row-cols-2">
            {VenueFacilities?.map((facility) => (
              <div key={facility} className="col mb-3">
                <div className="flex gap-2 items-center  ">
                  <Input
                    type="checkbox"
                    {...register("venueRequiredFacility")}
                    value={facility}
                    defaultChecked={venueData?.venueRequiredFacility?.includes(
                      facility
                    )}
                    className="common-checkbox"
                  />
                  <label className="text-[#4E5969] text-xs mt-[10px]">
                    {facility}
                  </label>
                </div>
              </div>
            ))}
          </div>
          {errors.venueRequiredFacility && (
            <p className="text-red-500 text-xs">
              {errors.venueRequiredFacility.message}
            </p>
          )}
        </section>

        {/* Services Section */}
        <section className="mb-4">
          <h4 className="font-medium text-base mb-3">
            Services that are required
          </h4>
          <div className="row row-cols-lg-6 row-cols-md-3 row-cols-2">
            {VenueServices?.map((service) => (
              <div key={service} className="col mb-3">
                <div className="flex gap-2 items-center">
                  <Input
                    type="checkbox"
                    {...register("venueReuiredService")}
                    value={service}
                    defaultChecked={venueData?.venueReuiredService?.includes(
                      service
                    )}
                    className="common-checkbox"
                  />
                  <label className="text-[#4E5969] text-xs mt-[10px]">
                    {service}
                  </label>
                </div>
              </div>
            ))}
          </div>
          {errors.venueReuiredService && (
            <p className="text-red-500 text-xs">
              {errors.venueReuiredService.message}
            </p>
          )}
        </section>

        {/* Save & Proceed Button */}
        <div className="h-48 flex justify-center items-end">
          <button className="gradian-btn text-white px-3 py-2" type="submit">
            Save & Proceed
          </button>
        </div>
      </div>
    </form>
  );
}

export default OtherDetails;
